import { userInfo } from "os";
import languages from "./languages";
languages.init();

export const CHECKED_VAL = "checked"


let dateValite = function(dateStr){
    var dateReg = /[20|19]\d{2}[\-|\\]\d{2}[\-|\\]\d{2}/;
    if(!dateReg.test(dateStr)){
        return false;
    }
    var res = false;
    try{
        var dates = dateStr.match(/(\d{4})\-(\d{2})\-(\d{2})/);
        var year = parseInt(dates[1]);
        var month = parseInt(dates[2]);
        var day = parseInt(dates[3]);
        var monthLen = [31,28,31,30,31,30,31,31,30,31,30,31];
        if(year%4==0&&year%100 !==0 || year%400 ==0 ){
            monthLen[1] = 29;
        }
        var maxLength = monthLen[month-1];
        res = day <= maxLength;
    }catch(err){
        res = false;
    }
    return res;
}

let emptyCheck = function(){
    
}

let phoneValite = function(phone){
    return /^\d{6,18}$/.test(phone);

}

let idValidate = function(){

}

let facebookValidate = function(facebookName){
    return facebookName == undefined || facebookName.length > 0 && facebookName.length <= 60;
}


export let accountNameValidate = function(accountName){
    var regExp =  /^([a-zA-Z0-9]|[_\.@]){6,30}$/;
    return regExp.test(accountName);
}

export let pwdValidate = function(pwd){
    var regExp = /^[\W|\w]{6,20}$/;
    return regExp.test(pwd)
}

let getValidateFaileRes = function(errmsg){
    return {
        dirty : true,
        errmsg
    }
}

let idCardValidate = function(idCard){
    return idCard && idCard.length > 0 && idCard.length <= 60;
}

let getValidateSuccessRes = function(){
    return {
        dirty : false,
        errmsg : ""
    }
}

let realNameValidate = function(_val){
    var length = _val && _val.replace(/[^\x00-\xff]/g, "**").length;
    return   length >= 4 && length <= 60;
}

export let emailValidate = function(email){
    let emailReg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
    return emailReg.test(email);
}

export let bindEmailValidate = function(params){
    if(!emailValidate(params.email)){
        return {
            dirty : true,
            errmsg : languages.get("emailVAlidateMsg")
        }
    }

    if(params.terms !== CHECKED_VAL){
        return {
            dirty : true,
            errmsg : languages.get("checkServiceTips")
        }
    }
    
    if(!params.ckcode){
        return {
            dirty : true,
            errmsg : languages.get("editVrfCodeTips")
        }
    }

    return {
        dirty : false,
        errmsg : ""
    }
}


export  let upgradeValite = function({terms,password,accountName,repassword}){
    if(terms !== CHECKED_VAL){
        return {
            dirty : true,
            errmsg : languages.get("checkServiceTips")
        }
    }
    if(!accountNameValidate(accountName)){
        return {
            dirty : true,
            errmsg :languages.get("accountValidateMsg")
        }
    }
    if(!pwdValidate(password)){
        return {
            dirty : true,
            errmsg : languages.get("pwdValidateMsg")
        }
    }
    if(password !== repassword){
        return {
            dirty : true,
            errmsg : languages.get("pwdRepeatTips")
        }
    }
   
    return {
        dirty : false,
        errmsg : ""
    }
}

export  let profileValidate = function(usrInfo){
   if(! realNameValidate(usrInfo.real_name) && undefined != usrInfo.real_name){
        return {
            dirty : true,
            errmsg : languages.get("realNameValidateTips")
        }
    }

    if(!dateValite(usrInfo.birthday)&& undefined != usrInfo.birthday){
        return {
            dirty : true,
            errmsg : languages.get("brithdayValidateTips")
        }
    }

    if(!phoneValite(usrInfo.phone) && undefined != usrInfo.phone){
        return {
            dirty : true,
            errmsg :languages.get("phoneValidateTips")
        }
    }
   
    if(usrInfo.terms !== CHECKED_VAL){
        return {
            dirty : true,
            errmsg : languages.get("checkServiceTips")
        }
    }

    if(!facebookValidate(usrInfo.fb_account)){
        return {
            dirty : true,
            errmsg :  languages.get("facebookValidateTips")
        }
    }

    if(usrInfo.id_card_country == '0' && undefined != usrInfo.id_card_number){
        return {
            dirty : true,
            errmsg : languages.get("areaSelectTips")
        }
    }

    if(!idCardValidate(usrInfo.id_card_number) && undefined != usrInfo.id_card_number){
        return {
            dirty : true,
            errmsg : languages.get("iDCardValidataTips")
        }
    }

    return {
        dirty : false,
        errmsg : ""
    }
}

export  let changePwdValite = function({password,newPassword,reNewPwd,terms}){
    if(terms !== CHECKED_VAL){
        return {
            dirty : true,
            errmsg : languages.get("checkServiceTips")
        }
    }
    if(!pwdValidate(password)){
        return {
            dirty : true,
            errmsg : languages.get("pwdValidateMsg")
        }
    }
    if(!pwdValidate(newPassword)){
        return {
            dirty : true,
            errmsg : languages.get("pwdValidateMsg")
        }
    }
    if(newPassword !== reNewPwd){
        return {
            dirty : true,
            errmsg : languages.get("pwdRepeatTips")
        }
    }
    return {
        dirty : false,
        errmsg : ""
    }
}

export  let safeQuessionValite = function(answers){
    for(let i=0,len = answers.length;i<len;i++){
        let quessionIndex = i + 1;
        if(answers[i].id == ""){
            return {
                dirty :true,
                errmsg : languages.get("slectQuessionTips"),
            }
        }
        if(answers[i].answer == ""){
            return {
                dirty :true,
                errmsg :  languages.get("answerTips"),
            }
        }
    }
    return {
        dirty :false,
        errmsg : "",
    }
}


export let getVerrifyCodeValidate = function(email){
    var validatePass = emailValidate(email);
    var res = validatePass?getValidateSuccessRes():getValidateFaileRes(languages.get("emailVAlidateMsg"));
    return res;
}

export let checkAccountValidate = function(params){
    if(params.uname == "" || params.uname == undefined){
        return {
            dirty : true,
            errmsg : languages.get("accountName")
        }
    }
    if(params.ckcode == "" || params.ckcode == undefined){
        return {
            dirty : true,
            errmsg : languages.get("editVrfCodeTips")
        }
    }

    return {
        dirty : false,
        errmsg : ""
    }
}


export let validateResetPwd = function(params){
    if(params.password == "" ){
        return {
            dirty : true,
            errmsg : languages.get("editPwdTips")
        }
    }

   
    if(params.repassword == "" ){
        return {
            dirty : true,
            errmsg : languages.get("editRepeatPwdTips")
        }
    }

    if(params.repassword !== params.password){
        return {
            dirty : true,
            errmsg : languages.get("pwdRepeatTips")
        }
    }

    if(!pwdValidate(params.password) || !pwdValidate(params.repassword)){
        return {
            dirty : true,
            errmsg : languages.get("pwdValidateMsg")
        }
    }


    return {
        dirty : false,
        errmsg : ""
    }
}

export let validateMigrateCode = function({pw,repw}){
    let regx=/\S{6,16}/;
    if(!regx.test(pw)){
        return {
            dirty : true,
            errmsg : "パスワードの長さは6～16文字にする"
        }
    }
    if(pw !== repw){
        return {
            dirty : true,
            errmsg : "パスワードの両回の入力は一致しない"
        }
    }
    return {
        dirty : false,
        errmsg : ""
    }
}

export let validateSwitchMigrateCode = function({followCode,password}){
    let regx=/\S{6,16}/;
    if(!followCode){
        return {
            dirty : true,
            errmsg : "正しい引き継ぎコードとパスワードを入力してください。"
        }
    }
    if(!regx.test(password)){
        return {
            dirty : true,
            errmsg : "パスワードの長さは6～16文字にする"
        }
    }
    return {
        dirty : false,
        errmsg : ""
    }
}